// extracted by mini-css-extract-plugin
export default {"state":"OrderWaiting_state__ZCOqR","state_btn":"OrderWaiting_state_btn__tWWER"};